import React, { useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import { ChevronRight } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

import { withMeetingContext } from 'Scenes/_root/meetingContext';
import InviteForm from './InviteForm';
import InMeeting from './InMeeting';
import PostMeeting from './PostMeeting';
import styles from './styles.scss';

export const DashboardForms = ({ isMobile, onDrawerToggle, registerMeetingCallbacks }) => {
  const [meetingState, setMeetingState] = useState();
  useEffect(() => {
    const deregisterMeetingCallbacks = registerMeetingCallbacks(`dashboardForms${isMobile && 'Mobile'}`, {
      onMeetingStart: (success) => {
        if (success) {
          setMeetingState('in-progress');
        }
      },
      onMeetingEnd: () => {
        setMeetingState('ended');
      },
    });
    setMeetingState('invite');
    return deregisterMeetingCallbacks;
  }, []);
  return (
    <React.Fragment>
      <div className={styles.drawerHeader}>
        <IconButton
          onClick={onDrawerToggle}
        >
          <ChevronRight />
        </IconButton>
      </div>
      <div className={styles.dashboardFormsWrapper}>
        {meetingState === 'invite' && (
          <InviteForm />
        )}
        {meetingState === 'in-progress' && (
          <InMeeting />
        )}
        {meetingState === 'ended' && (
          <PostMeeting
            isMobile={isMobile}
            onSubmitFeedback={() => setMeetingState('invite')}
          />
        )}
      </div>
    </React.Fragment>
  );
};

DashboardForms.propTypes = {
  isMobile: bool.isRequired,
  onDrawerToggle: func.isRequired,
  registerMeetingCallbacks: func.isRequired,
};

DashboardForms.defaultProps = {
  isMobile: false,
};

export default withMeetingContext(['registerMeetingCallbacks'])(DashboardForms);
